import $ from 'jquery';
import Swal from 'sweetalert2';
import { deleteAttachment, deletePointerAttachmentFromDefunto } from '~src/api';
import { onErrorShowMessage } from '~src/errors';

export const handleDeleteAttachment = async (event) => {
  event.preventDefault();
  event.stopPropagation();

  const editorAttachmentId = $(event.currentTarget).data(
    'delete-attachment-id'
  );
  const attachmentType = $(event.currentTarget).data('attachment-type');

  Swal.fire({
    title: 'Sei sicuro?',
    text: 'Vuoi cancellare la foto allegata?',
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#278e8e',
    cancelButtonColor: '#d33',
    cancelButtonText: 'No',
    confirmButtonText: 'Si, elimina',
  }).then((result) => {
    if (result.value) {
      Swal.fire({
        text: 'Sto eliminando la foto...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      deleteAttachment(editorAttachmentId)
        .then(() => {
          if (attachmentType === 'profilePhoto') {
            deletePointerAttachmentFromDefunto();
          }
          Swal.hideLoading();
          Swal.fire({
            title: 'Fatto!',
            html: "L'immagine &egrave; stata eliminata.",
            icon: 'success',
            confirmButtonColor: '#278e8e',
          });
        })
        .catch((err) => {
          console.error(err);
          onErrorShowMessage();
        });
    }
  });
};
